import { Chakra } from "@airhelp/react-ui-components";
import type { ReactNode } from "react";

const { List, Stack } = Chakra;

const ItemsList = ({ children }: { children: ReactNode }) => (
  <List>
    <Stack
      direction={{ base: "row", md: "column" }}
      align="left"
      spacing={{ base: 4, md: 8 }}
      overflow="scroll"
      sx={{
        msOverflowStyle: "none",
        "&::-webkit-scrollbar": {
          display: "none",
        },
      }}
    >
      {children}
    </Stack>
  </List>
);

export default ItemsList;
